import angular from 'angular';

ErrorController.$inject = ['$state'];

export function ErrorController($state) {
    const vm = angular.extend(this, {
        search: '',
        submit() {
            $state.go('home.fonts.listing', {
                name: vm.search,
            });
        },
    });
}
